import { useEffect, useState, useCallback } from 'react'
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography
} from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import {
  getAllByOrganizationAppicationID,
  getLoginIdp
} from '../../../../../services/organization/OrgAppUserController'
import Loader from '../../../../../components/ui-elements/loader'
import ImageContentCard from '../../../../../components/ui-elements/cards/ImageContentCard'
import { getAllOrganizationApplications } from '../../../../../store/reducers/organization/applications/orgApplicationAction'
import { getAllOrg } from '../../../../../store/reducers/organization/organization/organizationAction'
import WifiOffIcon from '@mui/icons-material/WifiOff';
import { IMAGES } from '../../../../../config/assets';

const DashboardPage = () => {
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(true)
  const [orgApplications, setOrgApplications] = useState([])
  const [organizationNames, setOrganizationNames] = useState({})
  const [assertionUrls, setAssertionUrls] = useState({})
  const [loadingAppId, setLoadingAppId] = useState(null)
  const organizations = useSelector(state => state.organization.organizations)
  const user = useSelector(state => state.user.user)
  const networkStatus = useSelector(
    state => state.orgApplications.networkStatus
  )
  const [openDialog, setOpenDialog] = useState(false) // State for opening dialog

  const [offlineAppName, setOfflineAppName] = useState('') // State for the offline app name
  const handleClickOfflineApp = appName => {
    setOfflineAppName(appName) // Store the app name for the dialog message
    setOpenDialog(true) // Open the dialog
  }

  const handleDialogClose = () => {
    setOpenDialog(false);
    setOfflineAppName('') // Reset the offline app name
  }
  const handleOfflineApplications = application => {
    handleClickOfflineApp(application.applicationName)

    // Your existing application handling logic here
    setLoadingAppId(application.organizationApplicationID)
  }
  // Fetch all organizations
  const fetchAllOrganizations = useCallback(async () => {
    try {
      await dispatch(getAllOrg()).unwrap() // Fetch all organizations
      setLoading(false)
    } catch (error) {
      console.error('Error fetching organizations:', error)
    } finally {
      setLoading(false)
    }
  }, [dispatch])
  // Fetch organizations when component mounts
  useEffect(() => {
    fetchAllOrganizations()
  }, [fetchAllOrganizations])
  // Fetch applications for the organization based on orgid
  const fetchOrgApplicationInfo = useCallback(
    async orgid => {
      try {
        const response = await dispatch(
          getAllOrganizationApplications({ organizationID: orgid })
        ).unwrap()
        setOrgApplications(response?.Records || [])
        setLoading(false)
      } catch (error) {
        console.error('Error fetching applications:', error)
      }
    },
    [dispatch]
  )

  useEffect(() => {
    console.log('organizations', organizations)

    if (organizations?.Records?.length) {
      (async () => {
        const orgAppDetails = []
        organizations.Records.forEach(async org => {
          const applications = await fetchOrgApplicationInfo(org.organizationID)
          orgAppDetails.push({ orgName: org.organizationName, applications })
        })

        // Once all applications are fetched, set state
        setOrgApplications(orgAppDetails)
      })()
    }
  }, [organizations, fetchOrgApplicationInfo, networkStatus])
  // Handle dynamic fetching of assertion URLs and organization names
  useEffect(() => {
    if (orgApplications.length === 0) return

    const appNames = orgApplications.map(app =>
      app.applicationName?.toLowerCase()
    )
    const urls = {}
    const orgNames = {}; (async () => {
      for (const name of appNames) {
        const matchedApp = orgApplications.find(
          app => app?.applicationName?.toLowerCase() === name
        )

        if (matchedApp) {
          try {
            const orgAppDetails = await getAllByOrganizationAppicationID({
              organizationApplicationID: matchedApp.organizationApplicationID
            })

            const assertionUrl =
              orgAppDetails.Records?.[0]?.assertionConsumerServiceURL
            const organizationName =
              orgAppDetails.Records?.[0]?.organizationName

            // Store the assertion URL and organization name
            urls[name] = assertionUrl
            orgNames[name] = organizationName
          } catch (error) {
            console.error(`Failed to fetch details for ${name}:`, error)
          }
        }
      }
      setAssertionUrls(urls)
      setOrganizationNames(orgNames)
    })()
  }, [orgApplications])

  const handleSalesForceCase = async (
    url,
    organizationApplicationID,
    orgid
  ) => {
    if (!url) {
      console.error('Callback URL is not ready.')

      return
    }

    try {
      const data = {
        username: user.username,
        type: 'SAML',
        password: '',
        organizationApplicationID: organizationApplicationID,
        organizationID: orgid
      }

      console.log('url', url)
      const response = await getLoginIdp(data)
      console.log('response', response)
      if (!response.token) {
        alert('Login failed. Please try again.')
        return
      }

      // Dynamically create and submit a form to callbackUrl
      const form = document.createElement('form')
      form.method = 'POST'
      form.action = url
      form.target = '_blank' // <- open in new tab

      const input = document.createElement('input')
      input.type = 'hidden'
      input.name = 'SAMLResponse'
      input.value = response.token

      form.appendChild(input)
      document.body.appendChild(form)
      form.submit()

      // Cleanup
      document.body.removeChild(form)
      setLoadingAppId(null)
    } catch (error) {
      setLoadingAppId(null)

      console.error('SAML login failed:', error)
    }
  }

  const handleSplunkCase = async (url, organizationApplicationID, orgid) => {
    if (!url) {
      console.error('Callback URL is not ready.')
      return
    }

    try {
      const data = {
        username: user.username,
        type: 'SAML',
        password: '',
        organizationApplicationID: organizationApplicationID,
        organizationID: orgid
      }

      console.log('url', url)
      const response = await getLoginIdp(data)
      console.log('response', response)
      if (!response.token) {
        alert('Login failed. Please try again.')
        return
      }

      // Dynamically create and submit a form to callbackUrl
      const form = document.createElement('form')
      form.method = 'POST'
      form.action = url
      form.target = '_blank' // <- open in new tab

      const input = document.createElement('input')
      input.type = 'hidden'
      input.name = 'SAMLResponse'
      input.value = response.token

      form.appendChild(input)
      document.body.appendChild(form)
      form.submit()

      // Cleanup
      document.body.removeChild(form)
      setLoadingAppId(null)
    } catch (error) {
      setLoadingAppId(null)

      console.error('SAML login failed:', error)
    }
  }
  const handleJuniperCase = async (url, routerName) => {
    if (!url) {
      console.error('Callback URL is not ready.')
      return
    }

    try {

      const data = {
        userName: 'emilyjones',
        userPass: 'Pa$$w0rd111',
        routerName: routerName
      }

      const proxyWindow = window.open(url, '_blank');

      const sendMessage = () => {
        if (proxyWindow) {
          proxyWindow.postMessage(data, url); // must match proxy origin
          console.log('[Parent] Sent credentials to proxy window');
        }
      };

      // Try a few times in case proxy takes time to load
      let tries = 0;
      const interval = setInterval(() => {
        if (proxyWindow && !proxyWindow.closed) {
          sendMessage();
          tries++;
          if (tries >= 5) clearInterval(interval);
        } else {
          clearInterval(interval);
        }
      }, 1000);

    } catch (error) {
      console.error('Expected failure:', error);
      setLoadingAppId(null)

      console.error('SAML login failed:', error)
    }
  }


  const handleApplications = application => {
    setLoadingAppId(application.organizationApplicationID)

    const appName = application.applicationName?.toLowerCase()
    const url = assertionUrls[appName]

    const token = localStorage.getItem('getchkdjwt')
    const parsedData = JSON.parse(token);
    const parsedtoken = parsedData.token;
    if (url) {
      switch (appName) {
        case 'salesforce':
          handleSalesForceCase(
            url,
            application.organizationApplicationID,
            application.organizationID
          )
          break
        case 'personnel':
          if (url && token) {
            const normalizedUrl = url.endsWith('/') ? url.slice(0, -1) : url

            const popup = window.open(normalizedUrl, '_blank')
            if (popup) {
              popup.name = JSON.stringify({
                token: parsedtoken ?? '',
                orgappid: application.organizationApplicationID ?? '',
                orgid: application.organizationID ?? ''
              })
            }
            setLoadingAppId(null)
          } else {
            setLoadingAppId(null)
            alert(`No assertion URL or token found for ${appName}`);

          }
          break


        case 'Satellite Access Request':
          if (url && token) {

            const normalizedUrl = url.endsWith('/') ? url.slice(0, -1) : url

            const popup = window.open(normalizedUrl, '_blank')
            if (popup) {
              popup.name = JSON.stringify({
                token: parsedtoken ?? '',
                orgappid: application.organizationApplicationID ?? '',
                orgid: application.organizationID ?? ''
              })
            }
            setLoadingAppId(null)
          } else {
            setLoadingAppId(null)
            alert(`No assertion URL or token found for ${appName}`);

          }
          break
        case 'workflow':
          if (url && token) {

            const normalizedUrl = url.endsWith('/') ? url.slice(0, -1) : url

            const popup = window.open(normalizedUrl, '_blank')
            if (popup) {
              popup.name = JSON.stringify({
                token: parsedtoken ?? '',
                orgappid: application.organizationApplicationID ?? '',
                orgid: application.organizationID ?? ''
              })
            }
            setLoadingAppId(null)
          } else {
            setLoadingAppId(null)
            alert(`No assertion URL or token found for ${appName}`);

          }
          break
        case 'asset location':
          if (url && token) {
            const normalizedUrl = url.endsWith('/') ? url.slice(0, -1) : url

            const popup = window.open(normalizedUrl, '_blank')
            if (popup) {
              popup.name = JSON.stringify({
                token: parsedtoken ?? '',
                orgappid: application.organizationApplicationID ?? '',
                orgid: application.organizationID ?? ''
              })
            }
            setLoadingAppId(null)
          } else {
            setLoadingAppId(null)
            alert(`No assertion URL or token found for ${appName}`);

          }
          break
        case 'splunk':
          handleSplunkCase(
            url,
            application.organizationApplicationID,
            application.organizationID
          )
          break
        case 'juniper conductor':
          handleJuniperCase(url, 'Conductor')

          break
        case 'juniper router 1':
          handleJuniperCase(url, 'Router1')
          break
        case 'juniper router 2':
          handleJuniperCase(url, 'Router2')
          break
        default:
          if (url && token) {

            const normalizedUrl = url.endsWith('/') ? url.slice(0, -1) : url

            const popup = window.open(normalizedUrl, '_blank')
            if (popup) {
              popup.name = JSON.stringify({
                token: parsedtoken ?? '',
                orgappid: application.organizationApplicationID ?? '',
                orgid: application.organizationID ?? ''
              })
            }
            setLoadingAppId(null)
          } else {
            setLoadingAppId(null)
            alert(`No assertion URL or token found for ${appName}`);

          }
          break
      }
    } else {
      alert(`No assertion URL found for ${appName}`);

    }
  }
  const getAppImageByName = appName => {
    switch (appName.toLowerCase()) {
      case 'asset location':
        return IMAGES.ASSETMANAGEMENT;
      case 'personnel':
        return IMAGES.HCM;
      case 'juniper conductor':
        return IMAGES.JUNIPER;
      case 'juniper router 1':
        return IMAGES.JUNIPER;
      case 'juniper router 2':
        return IMAGES.JUNIPER;
      case 'salesforce':
        return IMAGES.SALESFORCE;
      case 'splunk':
        return IMAGES.SPLUNK;
      default:
        return ''
    }
  }

  const getFormattedTitle = appName => {

    switch (appName?.toLowerCase()) {
      case 'asset location':
        return 'Hardware Management'
      case 'personnel':
        return 'Human Resources'
      default:
        return `${appName}`
    }
  }



  return (
    <>
      <Box m={6}>
        <Box m={6}>

          {loading ? (
            <Loader />
          ) : (
            <Grid container spacing={4}>
              {Array.isArray(orgApplications) &&
                orgApplications.length > 0 &&
                orgApplications.map(application => {
                  const isNotAvailable = application.status === 'Not Available'
                  const disabled = isNotAvailable

                  return (
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      md={3}
                      key={application.organizationApplicationID}
                    >
                      <ImageContentCard
                        title={getFormattedTitle(application.applicationName)}
                        subTitle={
                          organizationNames[
                          application.applicationName?.toLowerCase()
                          ] || ''
                        }
                        image={getAppImageByName(application.applicationName)}
                        onClick={
                          !disabled
                            ? () => handleApplications(application)
                            : () => handleOfflineApplications(application)
                        }
                        disabled={disabled}
                      >
                        {loadingAppId ===
                          application.organizationApplicationID && <Loader />}
                      </ImageContentCard>
                    </Grid>
                  )
                })}
            </Grid>
          )}
          {/* Dialog for Offline Apps */}
          <Dialog open={openDialog} onClose={handleDialogClose}>
            <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <WifiOffIcon color='error' />
              App Unavailable
            </DialogTitle>
            <DialogContent>
              <Typography variant='body1'>
                You are currently offline. <strong>{offlineAppName}</strong>{' '}
                requires an internet connection to access.
              </Typography>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleDialogClose} color='primary'>
                Close
              </Button>
            </DialogActions>
          </Dialog>
        </Box>
      </Box>
    </>
  )
}

export default DashboardPage
